export function capitalizeWords(text) {
  if (!text) return null
  return text?.toLowerCase()?.split(' ')?.map(function(word) {
      return word?.charAt(0)?.toUpperCase() + word?.slice(1);
  })?.join(' ');
}